import { render, staticRenderFns } from "./UpdateContent.vue?vue&type=template&id=2dc1b6e2"
import script from "./UpdateContent.vue?vue&type=script&lang=js"
export * from "./UpdateContent.vue?vue&type=script&lang=js"
import style0 from "./UpdateContent.vue?vue&type=style&index=0&id=2dc1b6e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports